import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { ErrorResponse } from '../../Interface/ErrorResponse';
import { InterestTableDTO } from '../../Interface/Hook/Interest/InterestTableDTO';
import { InterestTableState, INITIAL_TABLE_STATE } from '../../Interface/Hook/Interest/InterestTableState';

import { PROPERTIES_PER_LABEL_FILTER } from '../../Constants/Interest/Filter';

import reduceTablePropertiesPerLabelData from '../../Reducer/ReduceTablePropertiesPerLabelData';
import useGetLabels from '../Interest/UseGetLabels';
import useFilterIsActual from '../Interest/UseFilterIsActual';

import { getAcceptationGuideData } from '../../Service/Interest/InterestService';
import { getPropertiesPerLabel } from '../../Service/ProductPropertiesAPIService';
import { tokenExpired } from '../../Store/Auth/action';
import { filterFinishedLoading, filterSubmitted } from '../../Store/Filter/action';


const useGetPropertiesPerLabel = (labels: string[]): InterestTableDTO => {
    const dispatch = useDispatch();
    const filterIsActual = useFilterIsActual(PROPERTIES_PER_LABEL_FILTER);
    const { allLabels } = useGetLabels(false);
    const [{ error, data, headers, loading }, setState] = useState<InterestTableState>(INITIAL_TABLE_STATE);

    const fetchData = useCallback(() => {
        if (!filterIsActual) dispatch(filterSubmitted());
        if (filterIsActual)
            if (labels.length === 0) {
                setState({ ...INITIAL_TABLE_STATE, error: true, loading: false });
                dispatch(filterFinishedLoading());
            } else if (labels.length > 0) {
                Promise.all([
                    getPropertiesPerLabel(labels),
                    getAcceptationGuideData(),
                ]).then(
                    ([result, acceptationGuideData]) => {
                        setState({
                            error: false,
                            ...reduceTablePropertiesPerLabelData(result, allLabels, acceptationGuideData),
                            loading: false,
                        });
                        dispatch(filterFinishedLoading());
                    },
                    (errorResult: ErrorResponse) => {
                        errorResult.code === 403
                            ? dispatch(tokenExpired())
                            : setState({ error: true, data, headers, loading: false });
                        dispatch(filterFinishedLoading());
                    },
                );
            }
    }, [allLabels, dispatch, filterIsActual, labels, data, headers]);

    useEffect(() => fetchData(), [labels]);

    return { data, error, headers, loading };
};

export default useGetPropertiesPerLabel;
